import request from '@/utils/h5Request.js';

// 根据字典类型查询字典数据信息
export function getDicts(dictType) {
  return request({
    url: '/system/dict/data/type/' + dictType,
    method: 'get'
  })
}


// 获取RSA公钥
export function getPublicKeyApi() {
  return request({
    url: `/auth/user/rsa/public-key`,
    method: 'get',
  });
}

// 获取图形验证码
export function getImgCodeApi() {
  return request({
    url: `/auth/user/getCode`,
    method: 'get',
  });
}

// 手机验证码
export function sendMobileCodeApi(data) {
  return request({
    url: `/auth/user/sendMobileCode`,
    method: 'post',
    data,
    headers: {
      'device-type': '7',
      'device-id': navigator.userAgent,
    },
  });
}

// 服务号H5登录接口
export function serviceLogin(data) {
  return request({
    url: `/auth/user/wechat/service/login`,
    method: 'post',
    data,
    headers: {
      'device-type': '7',
      'device-id': navigator.userAgent,
    },
  });
}

// 登录注册
export function serviceRegisterlogin(data) {
  return request({
    url: `/auth/user/wechat/service/registerlogin`,
    method: 'post',
    data,
    headers: {
      'device-type': '7',
      'device-id': navigator.userAgent,
    },
  });
}

// 解绑
export function serviceUnbound(data) {
  return request({
    url: `/auth/user/wechat/service/unbound`,
    method: 'post',
    data,
    headers: {
      'device-type': '7',
      'device-id': navigator.userAgent,
    },
  });
}

export function getInfo() {
  return request({
    url: '/auth/user/getInfoV2',
    method: 'get'
  })
}

// 服务号unionId登录接口
export async function unionLogin(data, wait) {
  if (wait) {
    await new Promise(resolve => { // 3秒请求一次，在此处等3秒
      setTimeout(() => {
        resolve({
          code: 200,
        })
      },5000)
    })
  }
  // 真实接口请求
  return request({
    url: `/auth/user/wechat/service/login`,
    method: 'post',
    data,
    headers: {
      'device-type': '7',
      'device-id': navigator.userAgent,
    },
  });
}

